import { Injectable } from "@angular/core";
import { Storage } from '@ionic/storage';
import { Estacao } from 'src/app/shared/models/estacao.model';

const EstacaoKey = 'monitorar-busca-recentes';

@Injectable({
  providedIn: 'root'
})
export class BuscaService {

  estacoes: any[] = [];

  constructor(
    private storage: Storage
  ) {
  }

  async init(): Promise<Estacao[]> {
    return this.estacoes = await this.storage.get(EstacaoKey) || [];
  }

  addEstacao(estacao: any): Promise<Estacao[]> {
    const e = this.estacoes.filter(e => {
      return e &&
        (e.idEstacao && estacao.idEstacao && e.idEstacao == estacao.idEstacao)
    });
    if (!e.length) {
      this.estacoes.unshift(estacao);
      this.estacoes = this.estacoes.slice(0, 4);
    }
    return this.sync();
  }

  private sync(): Promise<Estacao[]> {
    return this.storage.set(EstacaoKey, this.estacoes);
  }

}
